import React from "react";
import { Icon } from "@chakra-ui/react";

export const ToastWarningIcon = ({ ...props }) => {
  return (
    <Icon as="svg" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.9997 2.66675L1.33301 28.0001H30.6663L15.9997 2.66675ZM15.9997 8.00008L26.0397 25.3334H5.95967L15.9997 8.00008ZM14.6663 13.3334V18.6667H17.333V13.3334H14.6663ZM14.6663 21.3334V24.0001H17.333V21.3334"
        fill="#1A1A1A"
      />
    </Icon>
  );
};
